import { ReactNode } from 'react';

// Bolds everything from the template's first {{placeholder}} onward, per design.
export const boldPlaceholderTail = (rawTemplate: string, interpolated: string): ReactNode => {
    const placeholderIndex = rawTemplate.indexOf('{{');

    if (placeholderIndex === -1) return interpolated;

    return (
        <>
            {interpolated.slice(0, placeholderIndex)}
            <b>{interpolated.slice(placeholderIndex)}</b>
        </>
    );
};
